<div class="faq" *ngIf="data">
    <h3>{{ type }}</h3>
    <ins-details-accordion>
        <ins-details-accordion-item *ngFor="let onderwerpen of data.onderwerpen">
            <div title>{{ onderwerpen.onderwerp_omschrijving }}</div>
            <div content>
                <ng-container *ngIf="onderwerpen.vragen.length >= 1">
                    <ins-details-accordion>
                        <ins-details-accordion-item *ngFor="let vraag of onderwerpen.vragen">
                            <div title>{{ vraag.vraag_tekst }}</div>
                            <div content>
                                <ins-faq-item [vraag]="vraag"></ins-faq-item>
                            </div>
                        </ins-details-accordion-item>
                    </ins-details-accordion>
                </ng-container>
            </div>
        </ins-details-accordion-item>
    </ins-details-accordion>
</div>
